module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "meeting-type"
    }
  }, [_c('h1', [_vm._v("Tipos de reunião")]), _c('no-show-flow'), _c('hr'), _vm._m(0), _c('br'), _c('br'), _c('new-meeting-type', {
    on: {
      "created": _vm.createdMeetingType
    }
  }), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _vm._l((_vm.$store.getters.meetingTypesList), function(meeting_type) {
    return _c('list-item', {
      key: meeting_type.id,
      attrs: {
        "meeting_type": meeting_type
      },
      on: {
        "updated": _vm.updatedMeetingType,
        "destroy": _vm.openDestroyConfirmationModal
      }
    })
  })], 2)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.$store.getters.meetingTypeLoading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.getters.meetingTypeLoading),
      expression: "!$store.getters.meetingTypeLoading"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])], 1), _c('confirm-modal', {
    attrs: {
      "id": "confirm-destroy-meeting-type",
      "title": "Excluir Tipo de reunião",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.destroyMeetingType
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("Confirma exclusão do Tipo de reunião abaixo?")]), _c('br'), _c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.selected_meeting_type.title))]), _c('br'), _c('br')])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Crie categorias de reuniões de acordo com o seu processo."), _c('br'), _vm._v("As categorias te ajudam a filtrar, selecionar e analisar a efetividade das suas reuniões.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a70b4a7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/meetings/index.vue
// module id = 1078
// module chunks = 1